export default __webpack_public_path__ + "static/media/manage-application.e7ab5ffe.svg";